import axios from 'axios';
import config from '../../config';

const baseUrl = config.baseUrl;
const endpoint = '/api/informeFinalPlanOperativo';

const normalizarProyecto = (proyecto) => {
  if (!proyecto) return null;

  // Si viene como "P19", "P01", etc
  if (typeof proyecto === 'string') {
    const limpio = proyecto.replace(/^P/i, '');
    const num = Number(limpio);
    return isNaN(num) ? null : num;
  }

  // Si ya viene como número
  if (typeof proyecto === 'number') {
    return proyecto;
  }

  return null;
};

const getInformeFinalPlanOperativo = async (proyecto) => {
  const proyectoNum = normalizarProyecto(proyecto);
  if (!proyectoNum) {
    return { status: 400, data: [] };
  }

  try {
    const response = await axios.get(`${baseUrl}${endpoint}`, {
      params: { proyecto: proyectoNum },
      validateStatus: status => status < 500,
    });

    return {
      status: response.status,
      data: response.data || [],
    };
  } catch (error) {
    console.error('Error Informe Final:', error);
    return { status: 500, data: [] };
  }
};

export default getInformeFinalPlanOperativo;
